import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  CardActions,
  CardContent,
  Grid,
  MenuItem,
  TextField,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Radio,
} from "@material-ui/core";
import { ThemeWrapper } from "../common/ThemeWrapper";
import {
  NominalSizes,
  TempMeasurement,
  PressureMeasurement,
  Movement,
  FlowCondition,
  Application,
  LengthMeasurement,
  LeftFittings,
  RightFittings,
  FittingAlloys,
  FloatingFlangeFittings,
  HoseAlloy,
  BraidAlloy,
  HoseFilter,
  BraidFilter,
} from "../../constants/ConfigurationTool/Options";
import { getOr, flowRight } from "lodash/fp";
import { findByValue } from "../../utils/lookups";
import { ContentContainer } from "../common/ContentContainer";
import { useLabelStyles } from "../common/styles";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
  BlobProvider,
  Image,
  pdf,
} from "@react-pdf/renderer";
import TemperatureCalculator from "../temperature/TemperatureCalculator";
import { sendEmail } from "../../serviceWorker";

// Prevents MUI v4 Select from scrolling/jumping the (iframed) page into view when its menu opens
const selectMenuProps = {
  getContentAnchorEl: null,
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  disableScrollLock: true,
  // Long lists (e.g. the 28-option fitting dropdowns) render at full height
  // without this, which forces the outer (iframed) page to scroll to keep
  // the focused item in view. Capping height makes the menu scroll internally.
  // MUI auto-focuses the menu list (and the selected/first item) on open for
  // keyboard accessibility, which triggers the browser's native scrollIntoView
  // across the iframe boundary and drags the parent (penflex.com) page with
  // it. Disabling autofocus here removes the trigger for that jump.
  autoFocus: false,
  disableAutoFocusItem: true,
  disableAutoFocus: true,
  disableEnforceFocus: true,
  disableRestoreFocus: true,
};

export const ConfigurationTool = () => {
  //ok

  const [companyName, setCompanyName] = useState(undefined);
  const [email, setEmail] = useState(undefined);
  const [clientName, setProjectName] = useState(undefined);
  const [location, setClientProjectId] = useState(undefined);
  const [selectedNominalSize, setSelectedNominalSize] = useState("");
  const [maxOperatingTemp, setMaxOperatingTemp] = useState(undefined);
  const [maxOperatingTempType, setMaxOperatingTempType] =
    useState("fahrenheit");
  const [maxOperatingPressure, setMaxOperatingPressure] = useState(undefined);
  const [maxOperatingPressureType, setMaxOperatingPressureType] =
    useState("psi");
  const [selectedMovement, setSelectedMovement] = useState("");
  const [selectedFlowCondition, setSelectedFlowCondition] = useState("");
  const [selectedApplication, setSelectedApplication] = useState("");
  const [selectedHoseAlloy, setSelectedHoseAlloy] = useState("");
  const [selectedBraidAlloy, setSelectedBraidAlloy] = useState("");
  // const [liveLength, setLiveLength] = useState(undefined);
  // const [liveLengthType, setLiveLengthType] = useState('in');
  const [overallLength, setOverallLength] = useState(undefined);
  const [overallLengthType, setOverallLengthType] = useState("in");
  const [selectedLeftFitting, setSelectedLeftFitting] = useState("");
  const [selectedLeftFittingAlloy, setSelectedLeftFittingAlloy] = useState("");
  const [selectedLeftFittingAlloy2, setSelectedLeftFittingAlloy2] =
    useState("");
  const [selectedRightFitting, setSelectedRightFitting] = useState("");
  const [selectedRightFittingAlloy, setSelectedRightFittingAlloy] =
    useState("");
  const [selectedRightFittingAlloy2, setSelectedRightFittingAlloy2] =
    useState("");

  const [resultTempCalculation, setResultTempCalculation] = useState("");
  const [resultPressureCalculation, setResultPressureCalculation] =
    useState("");

  const [HoseSeriesAllBraidFlatAPI, setHoseSeriesAllBraidFlatAPI] = useState(
    [],
  );

  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // HoseSeriesAllBraidFlat to HoseSeriesAllBraidFlatAPI -- changed
  // braidPressure to braidPressure_1BRAID not yet
  // OD to OD_1BRAID not yet
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>
  // <<<<<<<<<<======================= changed  =======================>>>>>>>>>>>

  const [selected, setSelected] = React.useState("");

  const reset = useCallback(() => {
    setSelectedNominalSize();
    setMaxOperatingTemp("");
    setMaxOperatingTempType("fahrenheit");
    setMaxOperatingPressure("");
    setMaxOperatingPressureType("psi");
    setSelectedMovement();
    setSelectedFlowCondition();
    setSelectedApplication();
    setSelectedHoseAlloy();
    setSelectedBraidAlloy();
    // setLiveLength('');
    // setLiveLengthType('in');
    setOverallLength("");
    setOverallLengthType("in");
    setSelectedLeftFitting();
    setSelectedLeftFittingAlloy();
    setSelectedRightFitting();
    setSelectedRightFittingAlloy();
    setSelectedLeftFittingAlloy2();
    setSelectedRightFittingAlloy2();
    setSelected("");
  }, [
    setSelectedNominalSize,
    setMaxOperatingTemp,
    setMaxOperatingTempType,
    setMaxOperatingPressure,
    setMaxOperatingPressureType,
    setSelectedMovement,
    setSelectedFlowCondition,
    setSelectedApplication,
    setSelectedHoseAlloy,
    setSelectedBraidAlloy,
    // setLiveLength,
    // setLiveLengthType,
    setOverallLength,
    setOverallLengthType,
    setSelectedLeftFitting,
    setSelectedLeftFittingAlloy,
    setSelectedRightFitting,
    setSelectedRightFittingAlloy,
    setSelectedLeftFittingAlloy2,
    setSelectedRightFittingAlloy2,
    setSelected,
  ]);

  // convert pdf to file for sending to server
  const generate = async (data) => {
    const element = data.file;
    const myPdf = pdf(element);
    myPdf.updateContainer(element);
    const blob = await myPdf.toBlob();
    var file = new File([blob], "pdfname.pdf", {
      lastModified: new Date().getTime(),
    });
    createFormDataAndSendToServer({ blob: file, data });
  };

  const createFormDataAndSendToServer = (data) => {
    const formData = new FormData();
    formData.append("file", data.blob, "PenflexClient.pdf");
    formData.append("email", data.data.email);
    formData.append("name", data.data.name);
    formData.append("company", data.data.company);
    formData.append("location", data.data.location);
    sendEmail(formData);
  };

  const handleCompanyNameChange = (e) => {
    e.persist();
    setCompanyName(e.target.value);
  };
  const handleEmailChange = (e) => {
    e.persist();
    setEmail(e.target.value);
  };
  const handleProjectNameChange = (e) => {
    e.persist();
    setProjectName(e.target.value);
  };
  const handleClientProjectIdChange = (e) => {
    e.persist();
    setClientProjectId(e.target.value);
  };
  const handleNominalSizeSelection = (e) => {
    e.persist();
    setSelectedNominalSize(e.target.value);
  };
  const handleMaxOperatingTempChange = (e) => {
    e.persist();
    setMaxOperatingTemp(e.target.value);
  };
  const handleMaxOperatingTempTypeChange = (e) => {
    e.persist();
    setMaxOperatingTempType(e.target.value);
  };

  const handleMaxOperatingPressureChange = (e) => {
    e.persist();
    setMaxOperatingPressure(e.target.value);
  };
  const handleMaxOperatingPressureTypeChange = (e) => {
    e.persist();
    setMaxOperatingPressureType(e.target.value);
  };
  const handleMovementSelection = (e) => {
    e.persist();
    setSelectedMovement(e.target.value);
  };
  const handleFlowConditionSelection = (e) => {
    e.persist();
    //filterPenflexProducts();
    setSelectedFlowCondition(e.target.value);
  };
  const handleApplicationSelection = (e) => {
    e.persist();
    setSelectedApplication(e.target.value);
  };
  const handleHoseAlloySelection = (e) => {
    e.persist();
    setSelectedHoseAlloy(e.target.value);
    // setSelected('');
  };
  const handleBraidAlloySelection = (e) => {
    e.persist();
    setSelectedBraidAlloy(e.target.value);
  };
  // const handleLiveLengthChange = (e) => {
  //     e.persist();
  //     setLiveLength(e.target.value);
  // }
  // const handleLiveLengthTypeSelection = (e) => {
  //     e.persist();
  //     setLiveLengthType(e.target.value);
  // }
  const handleOverallLengthChange = (e) => {
    e.persist();
    setOverallLength(e.target.value);
  };
  const handleOverallLengthTypeSelection = (e) => {
    e.persist();
    setOverallLengthType(e.target.value);
  };
  const handleLeftFittingSelection = (e) => {
    e.persist();
    setSelectedLeftFitting(e.target.value);
  };
  const handleLeftFittingAlloySelection = (e) => {
    e.persist();
    setSelectedLeftFittingAlloy(e.target.value);
  };
  const handleLeftFittingAlloySelection2 = (e) => {
    e.persist();
    setSelectedLeftFittingAlloy2(e.target.value);
  };
  const handleRightFittingSelection = (e) => {
    e.persist();
    setSelectedRightFitting(e.target.value);
  };
  const handleRightFittingAlloySelection = (e) => {
    e.persist();
    setSelectedRightFittingAlloy(e.target.value);
  };
  const handleRightFittingAlloySelection2 = (e) => {
    e.persist();
    setSelectedRightFittingAlloy2(e.target.value);
  };

  const selectedLeftFittinglabel = flowRight(
    getOr("", "label"),
    findByValue(selectedLeftFitting),
  )(LeftFittings);

  const selectedRightFittinglabel = flowRight(
    getOr("", "label"),
    findByValue(selectedRightFitting),
  )(RightFittings);

  const selectedApplicationlabel = flowRight(
    getOr("", "label"),
    findByValue(selectedApplication),
  )(Application);

  const selectedNominalSizelabel = flowRight(
    getOr("", "label"),
    findByValue(selectedNominalSize),
  )(NominalSizes);

  const selectedHoseAlloylabel = flowRight(
    getOr("", "label"),
    findByValue(selectedHoseAlloy),
  )(HoseAlloy);

  const selectedBraidAlloylabel = flowRight(
    getOr("", "label"),
    findByValue(selectedBraidAlloy),
  )(BraidAlloy);

  const selectedMovementlabel = flowRight(
    getOr("", "label"),
    findByValue(selectedMovement),
  )(Movement);

  const selectedFlowConditionlabel = flowRight(
    getOr("", "label"),
    findByValue(selectedFlowCondition),
  )(FlowCondition);

  const maxOperatingTempTypelabel = flowRight(
    getOr("", "label"),
    findByValue(maxOperatingTempType),
  )(TempMeasurement);

  const maxOperatingPressureTypelabel = flowRight(
    getOr("", "label"),
    findByValue(maxOperatingPressureType),
  )(PressureMeasurement);

  const singleBraidPSIbyValue = flowRight(
    getOr("", "braidPressure"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const DBRbyvalue = flowRight(
    getOr("", "DBR"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const SBRbyvalue = flowRight(
    getOr("", "SBR"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const Seriesbyvalue = flowRight(
    getOr("", "series"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const wireDiabyvalue = flowRight(
    getOr("", "wireDia"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const wiresabyvalue = flowRight(
    getOr("", "wires"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const carriersabyvalue = flowRight(
    getOr("", "carriers"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const selectedNumberofBraidsbyvalue = flowRight(
    getOr("", "braids"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const ODbyValue = flowRight(
    getOr("", "OD"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const FindHoseFilter = flowRight(
    getOr("", "hosealloy"),
    findByValue(selectedHoseAlloy),
  )(HoseFilter);

  const FindBraidFilter = flowRight(
    getOr("", "braidalloy"),
    findByValue(selectedBraidAlloy),
  )(BraidFilter);

  const NominalVelue = flowRight(
    getOr("", "value"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const NominalLabel = flowRight(
    getOr("", "label"),
    findByValue(selected),
  )(HoseSeriesAllBraidFlatAPI);

  const avilableBraidAlloys = HoseAlloy.filter(
    (hosealloy) => hosealloy.value === selectedHoseAlloy,
  ).flatMap((option) => option.braidalloy);

  // const avilableHoseSeriesAll = [...maxOperatingPressureType === "psi" ? HoseSeriesAll.filter(series => series.Nominal === selectedNominalSize).filter(series => series.singleBraid >= maxOperatingPressure).filter(series => series.alloy === selectedHoseAlloy) : HoseSeriesAll.filter(series => series.Nominal === selectedNominalSize).filter(series => series.singleBraid >= (maxOperatingPressure / 0.0689476)).filter(series => series.alloy === selectedHoseAlloy), ...maxOperatingPressureType === "psi" ? HoseSeriesAll.filter(series => series.Nominal === selectedNominalSize).filter(series => series.doubleBraid >= maxOperatingPressure).filter(series => series.alloy === selectedHoseAlloy) : HoseSeriesAll.filter(series => series.Nominal === selectedNominalSize).filter(series => series.singleBraid >= (maxOperatingPressure / 0.0689476)).filter(series => series.alloy === selectedHoseAlloy)];

  //  const avilableHoseSeriesAll = ([...maxOperatingPressureType === "psi" ? HoseSeriesAll.filter(series => series.singleBraid >= maxOperatingPressure) : HoseSeriesAll.filter(series => series.singleBraid >= (maxOperatingPressure / 0.0689476)), ...maxOperatingPressureType === "psi" ? HoseSeriesAll.filter(series => series.doubleBraid >= maxOperatingPressure) : HoseSeriesAll.filter(series => series.doubleBraid >= (maxOperatingPressure / 0.0689476))]).filter(series => series.Nominal === selectedNominalSize).filter(series => series.alloy === selectedHoseAlloy);

  // const avilableHoseSeriesAll = (maxOperatingPressureType === "psi" ? HoseSeriesAllBraidFlat.filter(series => series.braidPressure >= maxOperatingPressure) : HoseSeriesAllBraidFlat.filter(series => series.braidPressure >= (maxOperatingPressure / 0.0689476))).filter(series => series.Nominal === selectedNominalSize).filter(series => series.alloy === selectedHoseAlloy);

  const avilableHoseSeriesAll2 = (
    maxOperatingPressureType === "psi"
      ? HoseSeriesAllBraidFlatAPI?.filter(
          (series) => series.braidPressure >= maxOperatingPressure,
        )
      : HoseSeriesAllBraidFlatAPI?.filter(
          (series) => series.braidPressure >= maxOperatingPressure / 0.0689476,
        )
  ).filter((series) => series.Nominal === selectedNominalSize);

  const avilableHoseSeriesAll = avilableHoseSeriesAll2.filter(function (el) {
    return (
      FindHoseFilter.includes(el.series) && FindBraidFilter.includes(el.series)
    );
  });

  const filteredBraidAlloysByValue = avilableBraidAlloys.filter(
    (hosealloy) => hosealloy.value === selectedBraidAlloy,
  );

  const sortSeries = (arr) => {
    const sortArr = ["P3", "P4", "700", "800", "900", "1400", "400"];
    return arr.sort(
      (a, b) => sortArr.indexOf(a.series) - sortArr.indexOf(b.series),
    );
  };

  //Table
  const handleTableRowClick = (event, name) => {
    let newSelected = selected;

    if (name !== selected) {
      newSelected = name;
    }
    setSelected(newSelected);
  };

  const isSelected = (name) => selected === name;

  const selectedSeriesFoo = () => {
    const checked = avilableHoseSeriesAll.map((row) => {
      const isItemSelected = isSelected(row.value);
      return isItemSelected;
    });
    const filteredArr = checked.filter((element) => element === true);
    const index = checked.indexOf(filteredArr[0]);
    return index !== -1 ? true : false;
  };

  const selectedSeries = selectedSeriesFoo();

  //PDF

  // Create styles
  const styles = StyleSheet.create({
    page: {
      flexDirection: "row",
      backgroundColor: "#ffffff",
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
      color: "#5e88a2",
    },
    image: {
      width: 200,
      height: 200,
      margin: 10,
    },
    white: {
      margin: 0,
      padding: 0,
      backgroundColor: "#ffffff",
    },
    section3: {
      margin: 0,
      padding: 0,
      backgroundColor: "#000BBB",
    },
    section4: {
      margin: 0,
      padding: 0,
      backgroundColor: "#BBBBBB",
    },
    sectionyourtechnicalinputbackground: {
      margin: 0,
      padding: 0,
      flexGrow: 1,
      backgroundColor: "#f3f3f3",
    },
    popupmenu: {
      disableAutoFocus: true,
      disableEnforceFocus: true,
      autoFocus: false,
      disableAutoFocusItem: true,
      autoFocusItem: false,
    },
  });

  // PSI working at
  const PSIWorking =
    maxOperatingTemp >= 70 && resultTempCalculation
      ? resultTempCalculation
      : singleBraidPSIbyValue;
  const PSIWorkingResult =
    maxOperatingTemp >= 70 &&
    resultPressureCalculation &&
    maxOperatingPressureTypelabel === "Bar"
      ? resultPressureCalculation.toFixed(2)
      : PSIWorking;

  const hasSeparateFlangeAlloy = (label) =>
    FloatingFlangeFittings.includes(label);

  // "MSS Type C Stub End with 150# Raised Face Slip-On Flange" becomes
  // "<stub end alloy> MSS Type C Stub End with <flange alloy> 150# Raised Face Slip-On Flange <side>"
  const fittingResult = (hos, side, alloy, alloy2) => {
    if (!hasSeparateFlangeAlloy(hos)) return hos;
    const separator = " with ";
    const splitAt = hos.indexOf(separator);
    const stubEnd = hos.slice(0, splitAt);
    const flange = hos.slice(splitAt + separator.length);
    return `${alloy} ${stubEnd}${separator}${alloy2} ${flange} ${side}`;
  };
  const operatingTemp = () => {
    if (maxOperatingTempTypelabel === "°C")
      return (maxOperatingTemp * 9) / 5 + 32;
    else return maxOperatingTemp;
  };
  function replaceTrademark(originalString) {
    return originalString?.replace(/™️/g, "\u2122");
  }
  function addTrademark(originalString) {
    if (
      originalString === "Inconel" ||
      originalString === "Monel" ||
      originalString === "Hastelloy"
    ) {
      const words = originalString.split(" ");
      words.splice(1, 0, "\u2122");
      return words.join("");
    } else return originalString;
  }
  const fittingResultLeft = (hos) =>
    fittingResult(
      hos,
      "Left",
      replaceTrademark(selectedLeftFittingAlloy),
      replaceTrademark(selectedLeftFittingAlloy2),
    );
  const fittingResultRight = (hos) =>
    fittingResult(
      hos,
      "Right",
      replaceTrademark(selectedRightFittingAlloy),
      replaceTrademark(selectedRightFittingAlloy2),
    );

  //nominal size for pdf
  const ODValue =
    overallLengthType === "mm" ? (ODbyValue * 25.4).toFixed(2) : ODbyValue;

  // Create Document Component
  const MyDoc = () => (
    <Document>
      <Page orientation="landscape" size="A4" wrap={true} style={styles.page}>
        <View
          style={[
            styles.sectionyourtechnicalinputbackground,
            { height: "50%", width: "40%" },
          ]}
        >
          <View style={styles.section}>
            <Text>Your Technical Input</Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "20" }}>
              Nominal Size (ID):{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Nominal Size (OD):{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Max Temperature:{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Max Pressure:{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Hose Alloy:{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Braid Alloy:{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Movement Type:{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Flow Condition:{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Static or Dynamic:{" "}
            </Text>
            {/* <Text style={{ fontSize: '10', color: 'black', marginTop: '5' }}>Approximate Length:  </Text> */}
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {/* Approx.  */}Overall Length:{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Left Fitting Alloy:{" "}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              Right Fitting Alloy:{" "}
            </Text>
          </View>
        </View>
        <View
          style={[
            {
              height: "50%",
              width: "20%",
              position: "absolute",
              marginLeft: "13%",
            },
          ]}
        >
          <View style={styles.section}>
            <Text> </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "20" }}>
              {selectedNominalSizelabel}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {Number(ODValue).toFixed(2)}
              {overallLengthType === "in" ? '"' : "mm"}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {maxOperatingTemp} {maxOperatingTempTypelabel}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {maxOperatingPressure} {maxOperatingPressureTypelabel}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {replaceTrademark(selectedHoseAlloylabel)}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {replaceTrademark(selectedBraidAlloylabel)}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {selectedMovementlabel}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {selectedFlowConditionlabel}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {selectedApplicationlabel}
            </Text>
            {/* <Text style={{ fontSize: '10', color: 'black', marginTop: '5' }}>{liveLength} {liveLengthType}</Text> */}
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {overallLength} {overallLengthType}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {replaceTrademark(selectedLeftFittingAlloy)}
            </Text>
            <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
              {replaceTrademark(selectedRightFittingAlloy)}
            </Text>
          </View>
        </View>
        <View style={[styles.section, { height: "50%", width: "60%" }]}>
          <Text>Drawing</Text>
          <View
            style={[
              {
                height: "100%",
                width: "45%",
                marginTop: "10%",
                position: "absolute",
              },
            ]}
          >
            {selectedLeftFitting ? <Image src={selectedLeftFitting} /> : null}
          </View>
          <View
            style={[
              {
                height: "100%",
                width: "45%",
                marginLeft: "55%",
                marginTop: "10%",
                position: "absolute",
              },
            ]}
          >
            {selectedRightFitting ? <Image src={selectedRightFitting} /> : null}
          </View>
          <View
            style={[
              { marginTop: "16%", marginLeft: "48%", position: "absolute" },
            ]}
          >
            <Text
              style={{
                fontSize: "8",
                color: "black",
                marginTop: "5",
                textAlign: "center",
              }}
            >
              {overallLength} {overallLengthType}
            </Text>
          </View>
        </View>

        <View style={[{ height: "50%", width: "100%", position: "absolute" }]}>
          <Text
            style={{
              fontSize: "10",
              color: "black",
              marginTop: "4%",
              textAlign: "center",
            }}
          >
            _________________________________________________________________________________________________________________________________________________
          </Text>
        </View>

        <View
          style={[
            styles.section,
            {
              width: "100%",
              marginTop: "37%",
              marginLeft: "10",
              position: "absolute",
            },
          ]}
        >
          <Text>Notes</Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "10" }}>
            1. Hose and braid are catalog-rated for {PSIWorkingResult}{" "}
            {maxOperatingPressureTypelabel} working at {maxOperatingTemp}{" "}
            {maxOperatingTempTypelabel}. End fitting capacity may limit pressure
            rating. Maintain bend radius no smaller than{" "}
            {selectedApplicationlabel === "Dynamic" ? DBRbyvalue : SBRbyvalue}".
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            2. Metal hose assembly fabricated using direct fitting attachment
            method in accordance with NAHAD corrugated metal hose assembly
            specification.
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            3. Braid and hose detail not shown to scale.
          </Text>
        </View>
        <View
          style={[
            styles.section,
            {
              width: "60%",
              height: "1%",
              marginTop: "50%",
              marginLeft: "10",
              position: "absolute",
            },
          ]}
        >
          <Text>Component</Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "20" }}>
            A. Corrugated Hose
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            B. {selectedNumberofBraidsbyvalue} layer of{" "}
            {addTrademark(selectedBraidAlloy)} braid
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            C. Braid ferrule
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            D. End fitting
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            E. End fitting
          </Text>
        </View>
        <View
          style={[
            styles.section,
            {
              maxWidth: "400px",
              flex: 1,
              width: "70%",
              height: "20%",
              marginTop: "50%",
              marginLeft: "18%",
              position: "absolute",
            },
          ]}
        >
          <Text>Description</Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "20" }}>
            Penflex {Seriesbyvalue}, {selectedNominalSizelabel}{" "}
            {replaceTrademark(selectedHoseAlloylabel)} corrugated Hose
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            Penflex {Seriesbyvalue}, {selectedNominalSizelabel}{" "}
            {addTrademark(selectedBraidAlloy)} braid ({carriersabyvalue} x{" "}
            {wiresabyvalue} x {wireDiabyvalue})
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            Band-type retainer ring each end
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            {fittingResultLeft(selectedLeftFittinglabel)}
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "5" }}>
            {fittingResultRight(selectedRightFittinglabel)}
          </Text>

          {/* <Text style={{ fontSize: '10', color: 'black', marginTop: '5' }}>{selectedLeftFittinglabel} Left</Text>
                    <Text style={{ fontSize: '10', color: 'black', marginTop: '5' }}>{selectedRightFittinglabel} Right</Text> */}
        </View>

        <View style={[{ height: "50%", width: "100%", position: "absolute" }]}>
          <Text
            style={{
              fontSize: "10",
              color: "black",
              marginTop: "53%",
              textAlign: "center",
            }}
          >
            _________________________________________________________________________________________________________________________________________________
          </Text>
        </View>

        <View
          style={[
            styles.sectionyourtechnicalinputbackground,
            {
              height: "29.2%",
              width: "35%",
              marginLeft: "65%",
              marginTop: "50%",
              position: "absolute",
            },
          ]}
        ></View>
        <View
          style={[
            styles.section,
            {
              width: "65%",
              marginTop: "52%",
              marginLeft: "66%",
              position: "absolute",
            },
          ]}
        >
          <Text style={{ fontSize: "10", color: "black", marginTop: "0" }}>
            Company: {companyName}
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "15" }}>
            Email: {email}
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "15" }}>
            Name: {clientName}
          </Text>
          <Text style={{ fontSize: "10", color: "black", marginTop: "15" }}>
            Location: {location}
          </Text>
        </View>
        <View
          style={[
            styles.section,
            {
              width: "33%",
              marginTop: "62%",
              marginLeft: "66%",
              position: "absolute",
            },
          ]}
        >
          <Text
            style={{
              fontSize: "10",
              color: "black",
              marginTop: "10",
              textAlign: "right",
            }}
          >
            Specify Penflex Products
          </Text>
          <Text
            style={{
              fontSize: "10",
              color: "black",
              marginTop: "5",
              textAlign: "right",
            }}
          >
            All Hose & Braid Products Have 100% Material Traceability
          </Text>
        </View>
      </Page>
    </Document>
  );

  const App = () => (
    <div>
      <PDFDownloadLink
        document={<MyDoc />}
        fileName="Penflex - Generated Drawing.pdf"
      >
        {/* <Button
                    variant="contained"
                    color="primary"
                    disabled={ !filteredBraidAlloysByValue.length | !selectedSeries | !clientName | !location | !companyName | !email | !selectedNominalSize | !maxOperatingTemp  | !maxOperatingPressure  | !selectedMovement | !selectedFlowCondition | !selectedApplication | !selectedHoseAlloy | !selectedBraidAlloy | !overallLength | !selectedLeftFitting | !selectedLeftFittingAlloy | !selectedRightFitting | !selectedRightFittingAlloy |  selected.length === 0} // !liveLength | 
                    style={{ float: 'right' }}
                >
                    {({ blob, url, loading, error }) =>
                        loading ? 'Loading document...' : 'Download now!'
                    }
                    <BlobProvider document={<MyDoc />}>
                        {({ url }) => (
                            <div 
                                onClick={() => window.open(url, '_blank')} 
                                target="_blank"
                            >
                                Generate Drawing
                            </div>
                        )}
                    </BlobProvider>
                </Button> */}

        <Button
          variant="contained"
          color="primary"
          disabled={
            !filteredBraidAlloysByValue.length ||
            !selectedSeries ||
            !clientName ||
            !location ||
            !companyName ||
            !email ||
            !selectedNominalSize ||
            !maxOperatingTemp ||
            !maxOperatingPressure ||
            !selectedMovement ||
            !selectedFlowCondition ||
            !selectedApplication ||
            !selectedHoseAlloy ||
            !selectedBraidAlloy ||
            !overallLength ||
            !selectedLeftFitting ||
            !selectedLeftFittingAlloy ||
            !selectedRightFitting ||
            !selectedRightFittingAlloy ||
            (hasSeparateFlangeAlloy(selectedLeftFittinglabel) &&
              !selectedLeftFittingAlloy2) ||
            (hasSeparateFlangeAlloy(selectedRightFittinglabel) &&
              !selectedRightFittingAlloy2) ||
            selected.length === 0
          } // !liveLength |
          style={{ float: "right", marginRight: 8 }}
          onClick={() =>
            generate({
              file: <MyDoc />,
              name: clientName,
              company: companyName,
              location: location,
              email: email,
            })
          }
        >
          <BlobProvider document={<MyDoc />}>
            {({ url }) => (
              <div onClick={() => window.open(url, "_blank")} target="_blank">
                {"Generate Drawing"}
              </div>
            )}
          </BlobProvider>
        </Button>
      </PDFDownloadLink>
    </div>
  );

  // const filterPenflexProducts = useCallback(() => {
  //TBD
  //     if (maxOperatingTemp != '' && maxOperatingPressure != '' && selectedNominalSize != 'novalue') {
  // 		var tempinF = (maxOperatingTempType == 'fahrenheit') ? maxOperatingTemp : (Math.round((maxOperatingTemp * 9/5 + 32) * 100) / 100);
  // 		var pressureinPSI = (maxOperatingPressureType == 'psi') ? maxOperatingPressure : (Math.round(maxOperatingPressure * 14.5037738 * 100) / 100);
  // 		var closestTempRow = penflexTemps({temperature:{'>=':tempinF}}).first();
  // 		var productsFound = false;
  //     //See if any alloys can handle temp/pressure settings
  // 		$.each(closestTempRow, function (index, value) {
  // 			//This will loop all keys (304, 316, Bronze, etc and do calcs on them)
  // 			if(index != 'temperature' && index != '___id' && index != '___s' && value != '-') {
  // 				var modifiedPressure = (pressureinPSI / (value*1));
  // 				penflexProducts({maxWork:{'>=':modifiedPressure},sizeID:{'==':selectedNominalSize},alloy:{'like':'/'+index}}).each(function (r) {
  // 						if(productsFound == true) return false;
  // 						productsFound = true;
  // 				});
  // 			}
  // 		});
  // 		if(productsFound == false) {
  // 			//resetAlloyFilters();
  // 			alert('Sorry, it appears that our system could not find products that meet your combined requirements for temperature and pressure. Please contact Penflex directly.');
  // 			return; //Bad temp/pressure settings
  // 		}
  // 	}
  // })

  const labelClasses = useLabelStyles();
  const labelProps = {
    classes: {
      root: labelClasses.root,
    },
  };

  const removeHoseAllow = () => {
    if (selectedNominalSize < 0.25 || selectedNominalSize > 12)
      return HoseAlloy;
    else {
      selectedHoseAlloy === "304" && setSelectedHoseAlloy("");
      return HoseAlloy.filter((item) => item.value !== "304");
    }
  };

  // ---- if 'psi' or 'bar'
  useEffect(() => {
    if (maxOperatingPressureType === "psi") {
      setMaxOperatingTempType("fahrenheit");
      setOverallLengthType("in");
    }
    if (maxOperatingPressureType === "bar") {
      setMaxOperatingTempType("celcius");
      setOverallLengthType("mm");
    }
  }, [maxOperatingPressureType]);
  // ---- if 'fahrenheit' or 'celcius'
  useEffect(() => {
    if (maxOperatingTempType === "fahrenheit") {
      setMaxOperatingPressureType("psi");
      setOverallLengthType("in");
    }
    if (maxOperatingTempType === "celcius") {
      setMaxOperatingPressureType("bar");
      setOverallLengthType("mm");
    }
  }, [maxOperatingTempType]);
  // ---- if 'in' or 'mm' or 'ft'
  useEffect(() => {
    if (overallLengthType === "mm") {
      setMaxOperatingPressureType("bar");
      setMaxOperatingTempType("celcius");
    }
    if (overallLengthType === "in" || overallLengthType === "ft") {
      setMaxOperatingPressureType("psi");
      setMaxOperatingTempType("fahrenheit");
    }
  }, [overallLengthType]);

  useEffect(() => {
    let isMounted = true;
    fetch(
      "https://penflexconfigurationtool.s3.amazonaws.com/HoseSeriesAllBraidFlatDataJSON.json",
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        if (!isMounted) return;
        if (typeof data === "object" && data[0]?.value !== undefined) {
          setHoseSeriesAllBraidFlatAPI(data);
        } else {
          throw new Error("Data format is not as expected.");
        }
      })
      .catch((error) => {
        if (!isMounted) return;
        alert(
          "There was a problem loading the data. Please refresh the page and try again.",
        );
        console.error(error);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <ThemeWrapper title={"Configuration Tool"}>
      <CardContent>
        <Typography variant="subtitle1" component="h2" color="secondary">
          <b>Please fill out the information below.</b>
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label={<span>Company</span>}
                  InputLabelProps={labelProps}
                  value={companyName}
                  onChange={handleCompanyNameChange}
                  fullWidth
                  type="text"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label={<span>Client Name</span>}
                  InputLabelProps={labelProps}
                  value={clientName}
                  onChange={handleProjectNameChange}
                  fullWidth
                  type="text"
                  required
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label={<span>Email</span>}
                  InputLabelProps={labelProps}
                  value={email}
                  onChange={handleEmailChange}
                  fullWidth
                  type="email"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label={<span>Location</span>}
                  InputLabelProps={labelProps}
                  value={location}
                  onChange={handleClientProjectIdChange}
                  fullWidth
                  type="text"
                  required
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Typography
          variant="subtitle1"
          component="h2"
          color="primary"
          display="block"
        >
          {/* <br></br>
                    <b> Please fill out your hose specifications below. As you make your selections, it will narrow the possible answers in the other filters to only what is compatible:</b> */}
          <div>
            <br></br>
          </div>
        </Typography>

        <ContentContainer>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    color="secondary"
                  >
                    <b>Hose Specifications</b>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="nominal-size-selection"
                    label={"Choose the Nominal Size (in/mm)"}
                    value={selectedNominalSize}
                    onChange={handleNominalSizeSelection}
                    fullWidth
                    required
                  >
                    {NominalSizes.map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label={<span>Max Operating Temp</span>}
                    InputLabelProps={labelProps}
                    value={maxOperatingTemp}
                    onChange={handleMaxOperatingTempChange}
                    fullWidth
                    type="number"
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="max-operating-temp-measurement-selection"
                    label={"Measurement"}
                    value={maxOperatingTempType}
                    onChange={handleMaxOperatingTempTypeChange}
                    fullWidth
                    required
                  >
                    {TempMeasurement.map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label={<span>Max Operating Pressure</span>}
                    InputLabelProps={labelProps}
                    value={maxOperatingPressure}
                    onChange={handleMaxOperatingPressureChange}
                    fullWidth
                    type="number"
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="max-operating-pressure-measurement-selection"
                    label={"Measurement"}
                    value={maxOperatingPressureType}
                    onChange={handleMaxOperatingPressureTypeChange}
                    fullWidth
                    required
                  >
                    {PressureMeasurement.map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    color="secondary"
                  >
                    <b>Movement Specifications</b>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="movement-selection"
                    label={"Select Movement"}
                    value={selectedMovement}
                    onChange={handleMovementSelection}
                    fullWidth
                    required
                  >
                    {Movement.map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="flow-selection"
                    label={"Flow Condition"}
                    value={selectedFlowCondition}
                    onChange={handleFlowConditionSelection}
                    fullWidth
                    required
                  >
                    {FlowCondition.map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="Application-selection"
                    label={"Static or Dynamic Application"}
                    value={selectedApplication}
                    onChange={handleApplicationSelection}
                    fullWidth
                    required
                  >
                    {Application.map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    color="secondary"
                  >
                    <br></br>
                    <b>Hose and Braid Alloy Selections</b>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="hose-alloy-selection"
                    label={"Select Hose Alloy"}
                    value={selectedHoseAlloy}
                    onChange={handleHoseAlloySelection}
                    fullWidth
                    required
                  >
                    {removeHoseAllow().map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="braid-alloy-selection"
                    label={"Select Braid Alloy"}
                    value={selectedBraidAlloy}
                    onChange={handleBraidAlloySelection}
                    fullWidth
                    required
                  >
                    {avilableBraidAlloys.map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    color="secondary"
                  >
                    {" "}
                    <br></br>
                    <b>Overall Length</b>
                  </Typography>
                </Grid>

                {/* <Grid item xs={6}>
                                        <TextField
                                            label={<span>Approx. Live Length</span>}
                                            InputLabelProps={labelProps}
                                            value={liveLength}
                                            onChange={handleLiveLengthChange}
                                            fullWidth
                                            type="number"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            select
                                            SelectProps={{ MenuProps: selectMenuProps }}
                                            id="live-length-measurement-selection"
                                            label={'Measurement'}
                                            value={liveLengthType}
                                            onChange={handleLiveLengthTypeSelection}
                                            fullWidth
                                            required
                                        >
                                            {
                                                LengthMeasurement.map((option) => (
                                                    <MenuItem key={option.label} value={option.value} >
                                                        {option.label}
                                                    </MenuItem>
                                                ))
                                            }
                                        </TextField>
                                    </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    label={<span>Overall Length</span>}
                    InputLabelProps={labelProps}
                    value={overallLength}
                    onChange={handleOverallLengthChange}
                    fullWidth
                    type="number"
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="overall-length-measurement-selection"
                    label={"Measurement"}
                    value={overallLengthType}
                    onChange={handleOverallLengthTypeSelection}
                    fullWidth
                    required
                  >
                    {LengthMeasurement.map((option) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>

            {selectedNominalSize &&
              maxOperatingTemp &&
              maxOperatingPressure &&
              selectedMovement &&
              selectedFlowCondition &&
              selectedApplication &&
              selectedHoseAlloy &&
              selectedBraidAlloy &&
              overallLength && // liveLength &&
              (avilableHoseSeriesAll.length > 0 &&
              filteredBraidAlloysByValue.length > 0 ? (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle1"
                        component="h2"
                        color="secondary"
                      >
                        {" "}
                        <br></br>
                        <b></b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TableContainer component={Paper}>
                        <Table size="small" aria-label="Hose Selection">
                          <TableHead style={{ backgroundColor: "#5b778b" }}>
                            <TableRow>
                              <TableCell
                                style={{
                                  color: "white",
                                  fontWeight: "bold",
                                  padding: "0",
                                }}
                                align="center"
                              >
                                Series
                              </TableCell>
                              <TableCell
                                style={{
                                  color: "white",
                                  fontWeight: "bold",
                                  padding: "0",
                                }}
                                align="center"
                              >
                                Hose Alloy
                              </TableCell>
                              <TableCell
                                style={{
                                  color: "white",
                                  fontWeight: "bold",
                                  padding: "0",
                                }}
                                align="center"
                              >
                                Braid Alloy
                              </TableCell>
                              <TableCell
                                style={{
                                  color: "white",
                                  fontWeight: "bold",
                                  padding: "0",
                                }}
                                align="center"
                              >
                                Hose O.D. (IN&nbsp;/&nbsp;MM)
                              </TableCell>
                              <TableCell
                                style={{
                                  color: "white",
                                  fontWeight: "bold",
                                  padding: "0",
                                }}
                                align="center"
                              >
                                # of Braids
                              </TableCell>
                              <TableCell
                                style={{
                                  color: "white",
                                  fontWeight: "bold",
                                  padding: "0",
                                }}
                                align="center"
                              >
                                Max Pressure @ 70F / 21.1C
                              </TableCell>
                              {selectedApplicationlabel === "Dynamic" ? (
                                <TableCell
                                  style={{ color: "white", fontWeight: "bold" }}
                                  align="center"
                                >
                                  Dynamic Radius (IN&nbsp;/&nbsp;MM)
                                </TableCell>
                              ) : (
                                <TableCell
                                  style={{ color: "white", fontWeight: "bold" }}
                                  align="center"
                                >
                                  Static Radius (IN&nbsp;/&nbsp;MM)
                                </TableCell>
                              )}
                              <TableCell
                                style={{ color: "white", fontWeight: "bold" }}
                                align="center"
                              >
                                Select
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {sortSeries(avilableHoseSeriesAll).map(
                              (row, index) => {
                                const isItemSelected = isSelected(row.value);
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                  <TableRow
                                    hover
                                    onClick={(event) =>
                                      handleTableRowClick(event, row.value)
                                    }
                                    role="checkbox"
                                    aria-checked={isItemSelected}
                                    tabIndex={-1}
                                    key={row.value}
                                    selected={isItemSelected}
                                  >
                                    <TableCell align="center">
                                      {row.series}
                                    </TableCell>
                                    <TableCell align="center">
                                      {selectedHoseAlloy}
                                    </TableCell>
                                    <TableCell align="center">
                                      {selectedBraidAlloy}
                                    </TableCell>
                                    <TableCell align="center">
                                      {row.OD.toFixed(2)} in <br></br>{" "}
                                      {(row.OD * 25.4).toFixed(2)}&nbsp;mm
                                    </TableCell>
                                    <TableCell align="center">
                                      {row.braids}
                                    </TableCell>
                                    <TableCell align="center">
                                      {row.braidPressure} PSI<br></br>{" "}
                                      {(row.braidPressure * 0.0689476).toFixed(
                                        2,
                                      )}
                                      &nbsp;bar
                                    </TableCell>
                                    {selectedApplicationlabel === "Dynamic" ? (
                                      <TableCell align="center">
                                        {row.DBR} in <br></br>{" "}
                                        {(row.DBR * 25.4).toFixed(2)}&nbsp;mm
                                      </TableCell>
                                    ) : (
                                      <TableCell align="center">
                                        {row.SBR} in <br></br>{" "}
                                        {(row.SBR * 25.4).toFixed(2)}&nbsp;mm
                                      </TableCell>
                                    )}
                                    <TableCell
                                      align="center"
                                      padding="checkbox"
                                    >
                                      <Radio
                                        checked={isItemSelected}
                                        inputProps={{
                                          "aria-labelledby": labelId,
                                        }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              },
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                alert(
                  "Sorry, it looks like our system filtered you down to products that are not possible. Please adjust some of your requirements, or contact Penflex directly.",
                )
              ))}
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    color="secondary"
                  >
                    {" "}
                    <br></br>
                    <b>Left Fitting</b>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    style={styles.popupmenu}
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="left-fitting-selection"
                    label={"Fitting 1 (Left)"}
                    value={selectedLeftFitting}
                    onChange={handleLeftFittingSelection}
                    fullWidth
                    required
                  >
                    {LeftFittings.sort().map((option) => (
                      <MenuItem
                        style={styles.popupmenu}
                        key={option.label}
                        value={option.value}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    style={styles.popupmenu}
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="left-braid-alloy-selection"
                    label={
                      hasSeparateFlangeAlloy(selectedLeftFittinglabel)
                        ? "Select Stub End Alloy"
                        : "Select Fitting Alloy"
                    }
                    value={selectedLeftFittingAlloy}
                    onChange={handleLeftFittingAlloySelection}
                    fullWidth
                    required
                  >
                    {FittingAlloys.map((option) => (
                      <MenuItem
                        style={styles.popupmenu}
                        key={option.label}
                        value={option.label}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {hasSeparateFlangeAlloy(selectedLeftFittinglabel) && (
                  <Grid item xs={12}>
                    <TextField
                      style={styles.popupmenu}
                      select
                      SelectProps={{ MenuProps: selectMenuProps }}
                      id="left-braid-alloy-selection2"
                      label={"Select Flange Alloy"}
                      value={selectedLeftFittingAlloy2}
                      onChange={handleLeftFittingAlloySelection2}
                      fullWidth
                      required
                    >
                      {FittingAlloys.map((option) => (
                        <MenuItem
                          style={styles.popupmenu}
                          key={option.label}
                          value={option.label}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    color="secondary"
                  >
                    {" "}
                    <br></br>
                    <b>Right Fitting</b>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    style={styles.popupmenu}
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="right-fitting-selection"
                    label={"Fitting 1 (Right)"}
                    value={selectedRightFitting}
                    onChange={handleRightFittingSelection}
                    fullWidth
                    required
                  >
                    {RightFittings.sort().map((option) => (
                      <MenuItem
                        style={styles.popupmenu}
                        key={option.label}
                        value={option.value}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    style={styles.popupmenu}
                    select
                    SelectProps={{ MenuProps: selectMenuProps }}
                    id="right-braid-alloy-selection"
                    label={
                      hasSeparateFlangeAlloy(selectedRightFittinglabel)
                        ? "Select Stub End Alloy"
                        : "Select Fitting Alloy"
                    }
                    value={selectedRightFittingAlloy}
                    onChange={handleRightFittingAlloySelection}
                    fullWidth
                    required
                  >
                    {FittingAlloys.map((option) => (
                      <MenuItem
                        style={styles.popupmenu}
                        key={option.label}
                        value={option.label}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {hasSeparateFlangeAlloy(selectedRightFittinglabel) && (
                  <Grid item xs={12}>
                    <TextField
                      style={styles.popupmenu}
                      select
                      SelectProps={{ MenuProps: selectMenuProps }}
                      id="right-braid-alloy-selection2"
                      label={"Select Flange Alloy"}
                      value={selectedRightFittingAlloy2}
                      onChange={handleRightFittingAlloySelection2}
                      fullWidth
                      required
                    >
                      {FittingAlloys.map((option) => (
                        <MenuItem
                          style={styles.popupmenu}
                          key={option.label}
                          value={option.label}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </ContentContainer>

        <CardActions style={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            color="default"
            // disabled={!modelInfo}
            style={{ float: "right" }}
            onClick={reset}
          >
            {"Reset"}
          </Button>
          <App> </App>
        </CardActions>

        {/* </Grid> */}
      </CardContent>
      <TemperatureCalculator
        resultCalculation={setResultTempCalculation}
        setResultPressureCalculation={setResultPressureCalculation}
        ConfigurationTooCalculator={{
          value: NominalVelue,
          series: Seriesbyvalue,
          braids: selectedNumberofBraidsbyvalue,
          label: NominalLabel,
          temperature: operatingTemp(),
          pressure: maxOperatingPressure,
        }}
      />

      {/* <TemperatureCalculator /> */}
    </ThemeWrapper>
  );
};

export default ConfigurationTool;
